// extracted by mini-css-extract-plugin
export default {"root":"classes_root__sqsl5","avatar":"classes_avatar__Eogb3","pro-badge":"classes_pro-badge__ojq6M"};